import * as React from 'react';
import { useEffect } from "react";
import RestaurantHeader from "../restaurant/RestaurantHeader";
import {LocalizerHelper} from "../../helpers/localizerHelper";
import {useNavigate, useParams} from "react-router";
import ChuzeatFooter from "../footer/ChuzeatFooter";
import {LoaderGif} from '../loader';
import Screen from '../screen';
import './index.scss';
import MenuChooser from '../menu_chooser/MenuChooser';
import { setRestaurantId } from '../../features/restaurant/restaurant.slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { resetQuid, validateQuidSuccess } from '../../features/quid/quid.slice';
import { validateQuidService } from '../../features/quid/quid.service';
import { MenuFromApi } from '../../models/menu';

const QuidScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { quid } = useParams<{ quid:string }>();

  const quidMenus = useSelector((state: RootState) => state.quid.menus);
  const quidRestaurant = useSelector((state: RootState) => state.quid.restaurant);

  const [initialLoading, setInitialLoading] = React.useState(true);
  const [menuChooser, setMenuChooser] = React.useState(false);

  // Validate quid
  useEffect(() => {
    if (!quid) return;
    validateQuid(quid);
  }, [dispatch, quid]);
  
  useEffect(() => {
    if (quidRestaurant) {
      dispatch(setRestaurantId(quidRestaurant));
    }
    if(quidRestaurant && quidMenus){
      if (quidMenus.length > 0) {
        if(quidMenus.length === 1){
          const firstMenu = quidMenus[0];
          _goToMenu(firstMenu);
        }else{
          setMenuChooser(true);
        }
      }
    }
    
  }, [dispatch, quidRestaurant, quidMenus]);

  const validateQuid = async (quid: string) => {
      window.localStorage?.setItem('chuzeat_last_quid', quid);
      try{
        const result = await validateQuidService(quid);
        dispatch(validateQuidSuccess(result));
      }catch(e){
        dispatch(resetQuid());
      }
      setInitialLoading(false);
  };

  const _goToMenu = (menu: MenuFromApi) => {
      const url = `/quid/${quid}/${quidRestaurant}/menu/${menu.docId}`;
      navigate(url);
  }

  const renderLoading = () => (
    <LoaderGif
      image="/assets/loading_restaurant.gif"
      message={LocalizerHelper.localized('loading_msg_retrieve_services')}
    />
);

  const renderMenuChooser = () => (
    <MenuChooser goToMenu={_goToMenu} menus={quidMenus}></MenuChooser>
  );  

  const renderQuidScreen = () => (
    <div className="content_container with_footer">
      {
        <div className='container'>
          <p className="user_questions">{LocalizerHelper.localized('no_dining_tables_availables')}</p>
        </div>
      }
    </div>
  )

  const renderContent = () => {
    if(initialLoading) return renderLoading();
    if(menuChooser) return renderMenuChooser();
    return renderQuidScreen();
  }

  return <Screen className="screen restaurant-screen">
      <RestaurantHeader className='full-width' showBack={false} showCart={false} />
          {renderContent()}
      <ChuzeatFooter />
  </Screen>;
};

export default QuidScreen;
